import { Search, Download, Loader2 } from "lucide-react";
import { Input } from "../ui/input";
import { STATUSES } from "./Status";

const TYPES = [["", "All"], ["health", "Health"], ["life", "Life"], ["general", "Other"]];

export const LeadFilters = ({ filters, setFilters, counts, statusCounts, onExport, exporting }) => {
  const set = (k) => (e) => setFilters({ ...filters, [k]: e?.target ? e.target.value : e });
  const total = Object.values(counts || {}).reduce((a, b) => a + b, 0);
  return (
    <div className="flex flex-col gap-4" data-testid="lead-filters">
      <div className="flex flex-wrap gap-2">
        {TYPES.map(([v, l]) => (
          <button key={l} onClick={() => set("type")(v)} data-testid={`lead-filter-type-${l.toLowerCase()}`}
            className={`rounded-full px-4 py-2 text-sm border transition-colors ${filters.type === v ? "bg-[#0B281E] text-[#FAF8F5] border-[#0B281E]" : "bg-white border-[#0B281E]/15 hover:border-[#C88A35]"}`}>
            {l} <span className="opacity-70 ml-1">{v ? counts?.[v] ?? 0 : total}</span>
          </button>
        ))}
        <span className="hidden sm:block w-px bg-[#0B281E]/15 mx-1" />
        {[["", "Any status"], ...STATUSES].map(([v, l]) => (
          <button key={l} onClick={() => set("status")(v)} data-testid={`lead-filter-status-${v || "any"}`}
            className={`rounded-full px-4 py-2 text-sm border transition-colors ${filters.status === v ? "bg-[#C88A35] text-[#071510] border-[#C88A35]" : "bg-white border-[#0B281E]/15 hover:border-[#C88A35]"}`}>
            {l}{v && <span className="opacity-70 ml-1">{statusCounts?.[v] ?? 0}</span>}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_auto_auto] gap-3">
        <div className="relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#52635B]" />
          <Input value={filters.q} onChange={set("q")} placeholder="Search name, email, phone, state, ZIP" className="h-11 pl-10 rounded-xl bg-white" data-testid="lead-filter-search" />
        </div>
        <label className="flex items-center gap-2 text-xs text-[#52635B]">From<Input type="date" value={filters.date_from} onChange={set("date_from")} className="h-11 rounded-xl bg-white" data-testid="lead-filter-from" /></label>
        <label className="flex items-center gap-2 text-xs text-[#52635B]">To<Input type="date" value={filters.date_to} onChange={set("date_to")} className="h-11 rounded-xl bg-white" data-testid="lead-filter-to" /></label>
        <button onClick={onExport} disabled={exporting} data-testid="lead-export-btn" className="h-11 inline-flex items-center justify-center gap-2 rounded-full bg-[#C88A35] text-[#071510] px-5 text-sm font-semibold hover:bg-[#E5A855] transition-colors disabled:opacity-60">
          {exporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} Export CSV
        </button>
      </div>
    </div>
  );
};
